export default __webpack_public_path__ + "static/media/oneid-plain-success.2dda7652.svg";